// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1C-e_","title":"AfterBackImages_title__1KgVO","images":"AfterBackImages_images__25NdV"};